const toBoolean = (value: string | undefined, defaultValue: boolean): boolean => {
  if (value === undefined) {
    return defaultValue;
  }
  const normalised = value.trim().toLowerCase();
  if (normalised === "" || normalised === "0" || normalised === "false" || normalised === "off") {
    return false;
  }
  if (normalised === "1" || normalised === "true" || normalised === "on" || normalised === "yes") {
    return true;
  }
  return defaultValue;
};

export const featureFlags = {
  canvasExperiment: toBoolean(process.env.REACT_APP_ENABLE_CANVAS_EXPERIMENT, true),
  transformationPreview: toBoolean(process.env.REACT_APP_ENABLE_DISTRIBUTED_PREVIEW, true),
  workspaceExperiment: toBoolean(process.env.REACT_APP_ENABLE_WORKSPACE_EXPERIMENT, true),
};

export type FeatureFlags = typeof featureFlags;
